import { StyledBorderedWrapper } from './styles';
export const BorderedWrapper = ({ children }: { children: React.ReactNode }) => {
  return <StyledBorderedWrapper>{children}</StyledBorderedWrapper>;
};
